import DOC from './documentRepository'
import Repository from './Repository'

const action = 'response-payments'

export default {
  listAll() {
    return Repository.get(action)
  },
  listById(id) {
    return Repository.get(`${action}?response_id=${id}`)
  },
  listByLoadDaysId(ids) {
    return Repository.get(`${action}?load_days_id=${ids.join(',')}`)
  },
  create(data) {
    return Repository.post(action, data)
  },
  updateDates(file) {
    return Repository.post(`${action}/mass-update/dates`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  update(id, data) {
    return Repository.post(`${action}/${id}`, data)
  },
  delete(id) {
    return Repository.delete(`${action}/${id}`)
  },
  print(id) {
    return DOC.getReportLink(`${action}/${id}/print`)
    // return Repository.get(link);
  },
}
